<!-- クーポン選択 -->
<template>
  <!-- 所持しているクーポンの一覧 -->
  <TemplateMfittSelectCoupon v-if="isReadyToDraw" />

  <!-- 描画ローディング -->
  <DialogInitialLoading v-else :timeout-seconds="7000" />
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

import TemplateMfittSelectCoupon from "@/views/Templates/MFITT/TemplateMfittSelectCoupon";

import nativeHandlerService from "@/services/nativeHandler";

// API
import API from "@/API";

export default {
  name: "MfittSelectCoupon",
  components: {
    TemplateMfittSelectCoupon,
  },
  setup() {
    const store = useStore();

    // ログインしているかどうか
    const isLogin = store.getters["common/isLogin"];

    const isReadyToDraw = ref(false);

    onMounted(async () => {
      if (!isLogin) {
        // 未ログインの場合はダイアログ
        nativeHandlerService.returnNativeAppToAccountPage();
        // 未ログインのダイアログは、ダイアログ外を押しても閉じてしまうので、対策として10秒後にネイティブに戻る
        setTimeout(backToMfittIndexPage, 10000);
      } else {
        await API.getMyCoupons();
        // 予約画面から戻ってクーポンの使用を切り替えた場合、前に選択した情報を参照して不具合になることがあるのでクリアする
        store.commit("MFITT/setInputtedInfoOnBooking", null);
        isReadyToDraw.value = true;
      }
    });

    const backToMfittIndexPage = () => {
      nativeHandlerService.returnNativeAppMfittIndexPage();
    };

    return {
      isReadyToDraw,
      backToMfittIndexPage,
    };
  },
};
</script>
